const footerColumns = [
  {
    title: '资源导航',
    links: ['爱黑料网合集', '爱黑料网打包', '爱黑料网精选', '资源库总目录'],
  },
  {
    title: '社区',
    links: ['深夜吃瓜区', '合集速递', '时间线整理', '资源库答疑'],
  },
  {
    title: '帮助',
    links: ['新手指南', '下载说明', '打包目录规范', '意见反馈'],
  },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50">
                <i className="ri-emotion-laugh-line text-xl text-primary-700"></i>
              </span>
              <span className="font-heading text-lg font-bold">爱黑料网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-50/70">
              爱黑料网合集与打包资源集中呈现，精选图文集与黑料库一站获取。点开浏览完整资源库，省去翻找时间，高效吃瓜。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['爱黑料网精选', '资源库', '打包下载'].map((tag) => (
                <span key={tag} className="rounded-full bg-background-50/15 px-3 py-1 text-xs text-background-50/80">
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-3">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="whitespace-nowrap text-sm text-background-50/70 transition-colors hover:text-accent-300"
                      rel="nofollow"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-background-50/15 pt-6">
          <p className="text-xs leading-relaxed text-background-50/55">
            本站内容均为网友整理与社区投稿，仅作资源归档与浏览索引展示。若涉及版权或权益问题，可通过页面内反馈入口联系我们处理。
          </p>
          <div className="mt-4 flex flex-col gap-3 text-xs text-background-50/60 sm:flex-row sm:items-center sm:justify-between">
            <span>© 2026 爱黑料网 · 精选资源库一站收</span>
            <span className="flex items-center gap-4">
              <a href="#top" className="whitespace-nowrap transition-colors hover:text-accent-300" rel="nofollow">
                使用条款
              </a>
              <a href="#top" className="whitespace-nowrap transition-colors hover:text-accent-300" rel="nofollow">
                隐私说明
              </a>
              <a href="#top" className="whitespace-nowrap transition-colors hover:text-accent-300" rel="nofollow">
                站点地图
              </a>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}